import type { GetStaticPaths } from 'next'

import { Post, PostMetadata } from '~/content/blog/types'
import { getPost, renderPublishedPostsMetadata } from '~/server'
import { getLayoutProps } from '~/lib/layout'
import { PageProps } from '~/lib/types'
import { BLOG_TITLE_TEMPLATE } from '~/lib/seo'
import { Layout } from '~/components/Layout'
import MorePosts from '~/sections/MorePosts/MorePosts'
import PostArticle from '~/sections/PostArticle/PostArticle'

export const getStaticPaths: GetStaticPaths = async () => {
  const posts = await renderPublishedPostsMetadata()
  const paths = posts.map((post) => ({
    params: { slug: post.slug },
  }))

  return {
    fallback: 'blocking',
    paths,
  }
}

interface Params {
  params: {
    slug: string
  }
}

export const getStaticProps = async ({ params }: Params) => {
  const { slug } = params
  const post = await getPost(slug)

  if (!post) {
    return { notFound: true }
  }

  const publishedPosts = await renderPublishedPostsMetadata()
  const newPosts = publishedPosts.filter((publishedPost) => publishedPost.slug !== post.slug).splice(0, 2)

  return {
    props: {
      post,
      newPosts,
      layoutProps: getLayoutProps(),
    },
  }
}

interface Props extends PageProps {
  post: Post
  newPosts: PostMetadata[]
}

const BlogPost: React.FC<Props> = ({ post, newPosts, layoutProps }) => {
  return (
    <Layout
      {...layoutProps}
      titleTemplate={BLOG_TITLE_TEMPLATE}
      title={post.title}
      description={post.excerpt}
      shareImage={post.shareImage}
    >
      <PostArticle {...post} />
      <MorePosts posts={newPosts} />
    </Layout>
  )
}

export default BlogPost
